/* Attribution handoff only. Wetracked owns storefront advertising events. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document && !root.ViralCheckout) root.ViralCheckout = api.install(root, root.ViralCheckoutConfig || {});
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var STORAGE_KEY = 'viral_attribution_v1';
  var REVOCATIONS_KEY = 'viral_privacy_pending_v1';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var JOURNEY = /^[A-Za-z0-9_-]{16,128}$/;
  var GOOGLE_KEYS = ['gclid', 'gbraid', 'wbraid'];
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'site_source_name'];
  function permitted(c) { return c.marketing === true && c.saleOfData === true; }
  function consent(w) {
    var p = w.Shopify && w.Shopify.customerPrivacy;
    var c = { marketing: false, analytics: false, saleOfData: false, capturedAt: Date.now(), source: 'unknown' };
    if (!p) return c;
    try {
      c.marketing = typeof p.marketingAllowed === 'function' && p.marketingAllowed() === true;
      c.analytics = typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed() === true;
      c.saleOfData = typeof p.saleOfDataAllowed === 'function' && p.saleOfDataAllowed() === true;
      c.source = 'shopify_customer_privacy';
      if (w.navigator && w.navigator.globalPrivacyControl === true) c.saleOfData = false;
    } catch (_) { c.marketing = c.analytics = c.saleOfData = false; c.source = 'unknown'; }
    return c;
  }
  function clean(value, max) {
    if (typeof value !== 'string' || !value || value.length > (max || 300) || /[\u0000-\u001f<>]|\{\{|\}\}/.test(value)) return undefined;
    return value;
  }
  function safeUrl(raw, base) {
    try {
      var url = new URL(raw, base);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return undefined;
      // Query strings/fragments may contain contact information. Capture only named ad fields below.
      return url.origin + url.pathname;
    } catch (_) { return undefined; }
  }
  function cookie(w, key) {
    var parts = w.document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var item = parts[i].trim();
      if (item.indexOf(key + '=') === 0) {
        try { return decodeURIComponent(item.slice(key.length + 1)); } catch (_) { return undefined; }
      }
    }
  }
  function metaCookie(value) { return typeof value === 'string' && /^fb\.\d+\.\d{10,13}\.[A-Za-z0-9_.-]{1,500}$/.test(value) ? value : undefined; }
  function touch(w, at) {
    var url = new URL(w.location.href);
    var t = { capturedAt: at, landingUrl: safeUrl(url.href) };
    var ref = w.document.referrer && safeUrl(w.document.referrer);
    if (ref) t.referrer = ref;
    KEYS.forEach(function (k) { var value = clean(url.searchParams.get(k)); if (value) t[k] = value; });
    if (!t.ad_id) { var legacy = clean(url.searchParams.get('fbadid')); if (legacy) t.ad_id = legacy; }
    var click = clean(url.searchParams.get('fbclid'), 500);
    if (click && /^[A-Za-z0-9_-]+$/.test(click)) { t.fbclid = click; t.fbc = 'fb.1.' + at + '.' + click; }
    var tik = clean(url.searchParams.get('ttclid'), 1024);
    if (tik && /^[A-Za-z0-9._~-]+$/.test(tik)) t.ttclid = tik;
    GOOGLE_KEYS.forEach(function (key) {
      var value = clean(url.searchParams.get(key), 1024);
      if (value && /^[A-Za-z0-9._~-]+$/.test(value)) t[key] = value;
    });
    return t;
  }
  function nonDirect(t, origin) {
    if (GOOGLE_KEYS.some(function (key) { return !!t[key]; }) || t.ttclid || t.fbclid || KEYS.some(function (k) { return !!t[k]; })) return true;
    try { return !!t.referrer && new URL(t.referrer).origin !== origin; } catch (_) { return false; }
  }
  function signature(t) { return JSON.stringify([t.landingUrl, t.referrer || '', t.fbclid || '', t.ttclid || ''].concat(KEYS.concat(GOOGLE_KEYS).map(function (k) { return t[k] || ''; }))); }
  function uuid(w) {
    try {
      if (w.crypto.randomUUID) return w.crypto.randomUUID();
      var bytes = new Uint8Array(16); w.crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
    } catch (_) { return undefined; }
  }
  function createTracker(w, options) {
    var origin = options.appUrl.replace(/\/$/, '');
    var state, journeyId, pending, lastSavedSignature, epoch = 0;
    function removeStorage() { try { w.localStorage.removeItem(STORAGE_KEY); } catch (_) {} }
    function removeReference() {
      try { var url = new URL(w.location.href); if (url.searchParams.has('vc_j')) { url.searchParams.delete('vc_j'); w.history.replaceState(w.history.state, '', url.href); } } catch (_) {}
    }
    function load() {
      if (state) return;
      try {
        var stored = JSON.parse(w.localStorage.getItem(STORAGE_KEY) || 'null');
        if (stored && stored.v === 1 && stored.firstTouch && typeof stored.firstTouch.capturedAt === 'number' && Date.now() - stored.firstTouch.capturedAt < MAX_AGE && stored.firstTouch.capturedAt <= Date.now()) state = stored;
      } catch (_) {}
      if (!state) { removeStorage(); state = { v: 1 }; }
      var urlId = new URL(w.location.href).searchParams.get('vc_j');
      journeyId = urlId && JOURNEY.test(urlId) ? urlId : state.journeyId && JOURNEY.test(state.journeyId) ? state.journeyId : undefined;
    }
    function post(body) {
      var control = new w.AbortController();
      var timer = w.setTimeout(function () { control.abort(); }, 1200);
      return w.fetch(origin + '/api/tracking/journey', {
        method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: control.signal
      }).then(function (r) { if (!r.ok) throw new Error('journey_unavailable'); return r.json(); }).finally(function () { w.clearTimeout(timer); });
    }
    function privacyQueue() {
      try { var values = JSON.parse(w.localStorage.getItem(REVOCATIONS_KEY) || '[]'); return Array.isArray(values) ? values.filter(function (id) { return JOURNEY.test(id); }).slice(-20) : []; } catch (_) { return []; }
    }
    function revoke(id, c) {
      if (!id || !JOURNEY.test(id)) return Promise.resolve();
      // This minimal queue contains only references needed to enforce privacy, never
      // click/customer data. Keep failed suppressions for the next page's retry.
      var queue = privacyQueue(); if (queue.indexOf(id) === -1) queue.push(id);
      try { w.localStorage.setItem(REVOCATIONS_KEY, JSON.stringify(queue.slice(-20))); } catch (_) {}
      var denied = Object.assign({}, c, { marketing: false, saleOfData: false });
      return post({ journeyId: id, tracking: { v: 1, consent: denied } }).then(function () {
        var remaining = privacyQueue().filter(function (pendingId) { return pendingId !== id; });
        try { if (remaining.length) w.localStorage.setItem(REVOCATIONS_KEY, JSON.stringify(remaining)); else w.localStorage.removeItem(REVOCATIONS_KEY); } catch (_) {}
      }).catch(function () {});
    }
    function snapshot() {
      var c = consent(w);
      if (!permitted(c)) {
        var previous = journeyId;
        // Read only an opaque reference to suppress an earlier permitted journey.
        if (!previous) { try { var saved = JSON.parse(w.localStorage.getItem(STORAGE_KEY) || 'null'); if (saved && JOURNEY.test(saved.journeyId || '')) previous = saved.journeyId; } catch (_) {} }
        if (!previous) { try { var raw = new URL(w.location.href).searchParams.get('vc_j'); if (raw && JOURNEY.test(raw)) previous = raw; } catch (_) {} }
        state = undefined; journeyId = undefined; lastSavedSignature = undefined; epoch++;
        removeStorage(); removeReference();
        if (previous) revoke(previous, c);
        return { v: 1, consent: c };
      }
      load();
      var next = touch(w, Date.now());
      var old = state.lastTouch || state.firstTouch;
      // A reload of a genuine click keeps its original observation timestamp.
      if (next.fbclid && old && old.fbclid === next.fbclid && old.fbc) next.fbc = old.fbc;
      if (!state.firstTouch) state.firstTouch = next;
      if (!old || (nonDirect(next, w.location.origin) && signature(old) !== signature(next))) state.lastTouch = next;
      var latest = state.lastTouch || state.firstTouch;
      var fbp = metaCookie(cookie(w, '_fbp'));
      var fbc = latest && latest.fbc || metaCookie(cookie(w, '_fbc'));
      state.consent = c;
      if (!state.externalId) state.externalId = uuid(w);
      var ttp = clean(cookie(w, '_ttp'), 1024);
      if (ttp && /^[A-Za-z0-9._~-]+$/.test(ttp)) state.ttp = ttp;
      if (latest && latest.ttclid) state.ttclid = latest.ttclid;
      if (fbp) state.fbp = fbp;
      if (fbc) state.fbc = fbc;
      if (journeyId) state.journeyId = journeyId;
      try { w.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
      return JSON.parse(JSON.stringify(state));
    }
    function persist() {
      var tracking = snapshot();
      if (!permitted(tracking.consent)) return Promise.resolve({ tracking: tracking });
      if (pending) return pending;
      var fingerprint = JSON.stringify([tracking.firstTouch, tracking.lastTouch, tracking.fbp, tracking.fbc, tracking.ttp, tracking.ttclid, tracking.externalId, tracking.consent.marketing, tracking.consent.analytics, tracking.consent.saleOfData]);
      if (journeyId && fingerprint === lastSavedSignature) return Promise.resolve({ tracking: tracking, journeyId: journeyId });
      var capturedEpoch = epoch;
      pending = post({ tracking: tracking, journeyId: journeyId }).then(function (result) {
        var c = consent(w);
        if (capturedEpoch !== epoch || !permitted(c)) {
          return revoke(result && result.journeyId, c).then(function () { return { tracking: { v: 1, consent: c } }; });
        }
        if (!result || !JOURNEY.test(result.journeyId || '')) throw new Error('invalid_journey_reference');
        journeyId = result.journeyId; state.journeyId = journeyId; lastSavedSignature = fingerprint;
        try { w.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
        if (options.carryJourneyInUrl !== false) {
          try { var url = new URL(w.location.href); url.searchParams.set('vc_j', journeyId); w.history.replaceState(w.history.state, '', url.href); } catch (_) {}
        }
        return { tracking: snapshot(), journeyId: journeyId };
      }).catch(function () { return { tracking: snapshot(), journeyId: journeyId }; }).finally(function () { pending = undefined; });
      return pending;
    }
    function handoff() {
      // A pending request's earlier permission must never override a new denial.
      return persist().then(function () { var current = snapshot(); return { tracking: current, journeyId: permitted(current.consent) ? journeyId : undefined }; });
    }
    function refresh() {
      var c = consent(w);
      privacyQueue().forEach(function (id) { revoke(id, c); });
      return persist();
    }
    function start() {
      w.document.addEventListener('visitorConsentCollected', refresh);
      w.addEventListener('pageshow', refresh);
      if (w.Shopify && !w.Shopify.customerPrivacy && typeof w.Shopify.loadFeatures === 'function') {
        try { w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { refresh(); }); return; } catch (_) {}
      }
      refresh();
    }
    return { snapshot: snapshot, handoff: handoff, refresh: refresh, start: start };
  }
  function cartJson(body, w) {
    // Skip any request that cannot be represented losslessly. Files, duplicated keys,
    // unindexed array syntax and unknown properties must retain their original body.
    if (!(body instanceof w.FormData) && !(body instanceof w.URLSearchParams)) return undefined;
    var result = Object.create(null), items = Object.create(null), seen = Object.create(null), indexed = false, single = false, invalid = false;
    body.forEach(function (value, key) {
      if (invalid || typeof value !== 'string' || seen[key] || /(^|\[)(__proto__|prototype|constructor)(\]|$)/.test(key)) { invalid = true; return; }
      seen[key] = true;
      var match = /^items\[(\d{1,3})\]\[(id|quantity|selling_plan)\]$/.exec(key);
      var property = /^items\[(\d{1,3})\]\[properties\]\[([^\[\]]+)\]$/.exec(key);
      if (match || property) {
        indexed = true; var indexText = (match || property)[1], index = Number(indexText);
        if (String(index) !== indexText) { invalid = true; return; }
        var item = items[index] || (items[index] = Object.create(null));
        if (match) item[match[2]] = value;
        else { item.properties = item.properties || Object.create(null); item.properties[property[2]] = value; }
      } else if (/^(id|quantity|selling_plan)$/.test(key)) { single = true; result[key] = value; }
      else if (/^properties\[([^\[\]]+)\]$/.test(key)) {
        single = true; result.properties = result.properties || Object.create(null); result.properties[key.slice(11, -1)] = value;
      } else if (/^(sections|sections_url|form_type|utf8|product-id|section-id)$/.test(key)) result[key] = value;
      else invalid = true;
    });
    if (invalid || (indexed && single) || (!indexed && !single)) return undefined;
    var lines = indexed ? Object.keys(items).map(function (key, index) { if (Number(key) !== index) invalid = true; return items[key]; }) : [result];
    lines.forEach(function (line) {
      if (!/^\d+$/.test(line.id || '')) invalid = true;
      if (line.quantity !== undefined) {
        if (!/^\d+$/.test(line.quantity) || Number(line.quantity) < 1 || !Number.isSafeInteger(Number(line.quantity))) invalid = true;
        else line.quantity = Number(line.quantity);
      }
      if (line.selling_plan !== undefined && !/^\d+$/.test(line.selling_plan)) invalid = true;
    });
    if (invalid) return undefined;
    if (indexed) result.items = lines;
    return JSON.stringify(result);
  }
  function installCartJsonAdapter(w, enabled) {
    if (enabled !== true) return false;
    var previous = w.fetch;
    w.fetch = function (input, init) {
      var changed;
      try {
        // Never consume a Request body stream or alter cross-origin/vendor requests.
        if (typeof input === 'string' || input instanceof w.URL) {
          var url = new URL(String(input), w.location.href);
          if (init && String(init.method || 'GET').toUpperCase() === 'POST' && url.origin === w.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add(?:\.js)?$/i.test(url.pathname)) {
            var json = cartJson(init.body, w);
            if (json !== undefined) {
              changed = Object.assign({}, init); changed.body = json;
              changed.headers = new w.Headers(init.headers); changed.headers.set('Content-Type', 'application/json'); changed.headers.delete('Content-Length');
            }
          }
        }
      } catch (_) { changed = undefined; }
      return previous.call(this, input, changed || init);
    };
    return true;
  }
  function createAttemptStore(w) {
    var key = 'viral_checkout_attempt_v1', maxAge = 15 * 60 * 1000, memory;
    function canonical(value) {
      if (Array.isArray(value)) return '[' + value.map(canonical).join(',') + ']';
      if (value && typeof value === 'object') return '{' + Object.keys(value).filter(function (k) { return value[k] !== undefined; }).sort().map(function (k) { return JSON.stringify(k) + ':' + canonical(value[k]); }).join(',') + '}';
      return JSON.stringify(value);
    }
    function fingerprint(cart) {
      // Hash only checkout contents; never include click IDs, consent, or browser identity.
      var lines = (cart.items || []).map(function (line) { return canonical({ variantId: String(line.variant_id), quantity: line.quantity, properties: line.properties || null }); }).sort();
      return canonical({ token: cart.token || null, currency: cart.currency || null, items: lines,
        discount: (cart.cart_level_discount_applications && cart.cart_level_discount_applications[0] || {}).title || null });
    }
    function valid(record, fingerprint, now) {
      return record && record.fingerprint === fingerprint && JOURNEY.test(record.attemptId || '') && typeof record.createdAt === 'number' && record.createdAt <= now && now - record.createdAt < maxAge;
    }
    function get(cart) {
      var material = fingerprint(cart), now = Date.now();
      var hashed;
      try {
        hashed = w.crypto.subtle.digest('SHA-256', new w.TextEncoder().encode(material)).then(function (buffer) {
          return Array.prototype.map.call(new Uint8Array(buffer), function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
        });
      } catch (_) { hashed = Promise.reject(new Error('hash_unavailable')); }
      return hashed.then(function (digest) {
        var stored;
        try { stored = JSON.parse(w.localStorage.getItem(key) || 'null'); } catch (_) {}
        var found = valid(memory, digest, now) ? memory : valid(stored, digest, now) ? stored : undefined;
        if (!found) { var id = uuid(w); if (!id) return undefined; found = { fingerprint: digest, attemptId: id, createdAt: now }; }
        memory = found;
        try { w.localStorage.setItem(key, JSON.stringify(found)); } catch (_) {}
        return found.attemptId;
      }).catch(function () {
        // Without cryptographic hashing, keep comparison material only in memory.
        // Checkout still works; never persist the raw cart as a fingerprint.
        if (!valid(memory, material, now)) { var id = uuid(w); if (!id) return undefined; memory = { fingerprint: material, attemptId: id, createdAt: now }; }
        return memory.attemptId;
      });
    }
    return { get: get };
  }
  function installCheckout(w, options, tracker) {
    var app = options.appUrl.replace(/\/$/, '');
    var selectors = 'button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],form[action="/cart"] [type="submit"][name="checkout"],[data-viral-checkout]';
    var busy = false;
    var attempts = createAttemptStore(w);
    function settledCart(el) {
      try {
        if (!el.matches('#kaching-cart__checkout-button[data-kaching-checkout]') || el.disabled ||
            el.classList.contains('kaching-cart__checkout-button--loading') || w.document.visibilityState === 'hidden') return null;
        var host = el.closest('kaching-cart');
        if (!host || !w.kachingCartApi || typeof w.kachingCartApi.getCartData !== 'function') return null;
        var cart = w.kachingCartApi.getCartData();
        if (!cart || typeof cart.token !== 'string' || !cart.token || !/^[A-Z]{3}$/.test(cart.currency) ||
            !Array.isArray(cart.items) || !cart.items.length || !cart.cartPromotionsState ||
            !cart.items.every(function (item) { return Number.isSafeInteger(item.variant_id) && item.variant_id > 0 && Number.isSafeInteger(item.quantity) && item.quantity > 0; })) return null;
        return JSON.parse(JSON.stringify(cart));
      } catch (_) { return null; }
    }
    function go(ev) {
      var el = ev.target && ev.target.closest ? ev.target.closest(selectors) : null;
      if (ev.type === 'submit' && ev.target && ev.target.matches && ev.target.matches('form[action="/checkout"],form[action^="/checkout?"]')) el = ev.submitter || ev.target;
      if (!el || el.hasAttribute('data-viral-checkout-ignore')) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      if (busy) return;
      var readyCart = settledCart(el);
      busy = true; var original = el.textContent;
      var finished = false, failure = 'timeout', httpStatus;
      var ctrl = new w.AbortController();
      function restore() { busy = false; if (el.tagName === 'BUTTON') el.textContent = original; }
      // One deadline covers cart retrieval, attribution, hashing and checkout creation.
      // Alert delivery is independent of Redis and never delays the customer's fallback.
      var timer = w.setTimeout(function () {
        if (finished) return;
        finished = true; ctrl.abort();
        try {
          w.fetch(app + '/api/checkout-issue', {
            method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operation: 'storefront_handoff', reason: failure, httpStatus: httpStatus, elapsedMs: 10000 })
          }).catch(function () {});
        } catch (_) {}
        restore(); w.location.href = '/checkout';
      }, 10000);
      if (el.tagName === 'BUTTON') el.textContent = 'Loading…';
      Promise.all([
        readyCart ? Promise.resolve(readyCart) : w.fetch('/cart.js', { credentials: 'same-origin', signal: ctrl.signal }).then(function (r) { if (!r.ok) { httpStatus = r.status; throw new Error('cart_unavailable'); } return r.json(); }),
        tracker.handoff().catch(function () { return { tracking: { v: 1, consent: consent(w) } }; })
      ]).then(function (values) {
        if (finished) return;
        var cart = values[0], attribution = values[1];
        // Cart retrieval may have outlived a consent change after handoff resolved.
        var current = typeof tracker.snapshot === 'function' ? tracker.snapshot() : { v: 1, consent: consent(w) };
        if (!permitted(current.consent)) attribution = { tracking: current };
        else if (typeof tracker.snapshot === 'function') attribution = { tracking: current, journeyId: current.journeyId };
        if (!cart.items || !cart.items.length) throw new Error('empty');
        var payload = {
          token: cart.token, currency: cart.currency,
          items: cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || null }; }),
          discount: (cart.cart_level_discount_applications && cart.cart_level_discount_applications[0] || {}).title || undefined,
          tracking: attribution.tracking, journeyId: attribution.journeyId
        };
        return attempts.get(cart).then(function (attemptId) {
          if (finished) return;
          if (attemptId) payload.attemptId = attemptId;
          // Consent may change while the cryptographic cart fingerprint is computed.
          var latest = typeof tracker.snapshot === 'function' ? tracker.snapshot() : { v: 1, consent: consent(w) };
          if (!permitted(latest.consent)) { payload.tracking = latest; delete payload.journeyId; }
          return w.fetch(app + '/api/cart', {
            method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload), signal: ctrl.signal
          }).then(function (r) { if (!r.ok) { httpStatus = r.status; throw new Error('checkout_unavailable'); } return r.json(); });
        });
      }).then(function (result) {
        if (finished) return;
        var url = new URL(result && result.url);
        if (url.origin !== app || !/^\/c\/[A-Za-z0-9_-]+$/.test(url.pathname)) throw new Error('invalid_checkout_url');
        finished = true; w.clearTimeout(timer); restore(); w.location.href = url.href;
      }).catch(function (err) {
        if (finished) return;
        failure = ['cart_unavailable', 'checkout_unavailable', 'invalid_checkout_url'].indexOf(err && err.message) >= 0 ? err.message : 'checkout_unavailable';
        // Retain the ten second deadline even on a fast failure, with no duplicate attempts.
      });
    }
    w.document.addEventListener('click', go, true);
    w.document.addEventListener('submit', go, true);
  }
  function earlyShippingText(cart, props) {
    var settings = props && props.cartSettings;
    var rule = settings && settings.tieredPromotionsBar;
    if (!cart || cart.cartPromotionsState || cart._hasStorefrontDataInjected !== true || cart.currency !== 'USD' ||
        !props || props.currencyCode !== 'USD' || Number(props.currencyRate) !== 1 || props.locale !== 'en' ||
        !rule || !rule.isActive || rule.thresholdType !== 'cart-total' || rule.excludeProductsFromUnlockCount ||
        (rule.segmentation && rule.segmentation.enabled) || !Array.isArray(rule.tiers) || rule.tiers.length !== 1 ||
        (rule.marketSpecificTiers && rule.marketSpecificTiers.length) ||
        (props.autoAtcRules && props.autoAtcRules.rules && props.autoAtcRules.rules.some(function (r) { return r.isEnabled; })) ||
        !Array.isArray(cart.items) || !cart.items.length ||
        (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) ||
        (cart.allCodeDiscounts && cart.allCodeDiscounts.length)) return null;
    var tier = rule.tiers[0], subtotal = cart.total_price_without_shipping;
    if (tier.title !== 'Free shipping' || tier.type !== 'shipping-discount' || tier.discountType !== 'percentage' ||
        tier.discountAmount !== 100 || tier.excludeRatesAboveThreshold || !Number.isFinite(tier.threshold) ||
        !Number.isSafeInteger(subtotal) || subtotal < 0 ||
        rule.defaultText !== 'Add {{progress_needed}} to unlock {{next_promo_title}}!' ||
        rule.unlockedText !== '{{unlocked_promo_title}} unlocked!' || rule.allPromotionsUnlockedText ||
        cart.items.some(function (item) { return /promoHash|isAutoAtcGift/.test(JSON.stringify(item.properties || {})); })) return null;
    var remaining = Math.max(0, Math.round(tier.threshold * 100) - subtotal);
    return remaining ? 'Add $' + (remaining / 100).toFixed(2) + ' to unlock Free shipping!' : 'Free shipping unlocked!';
  }
  function installEarlyShipping(w) {
    if (!w.MutationObserver || !w.document.querySelector) return;
    var queued = false;
    function update() {
      queued = false;
      try {
        var host = w.document.querySelector('kaching-cart');
        if (!host) return;
        var native = host.querySelector('.kaching-cart__tiered-promotions-bar-text:not([data-ss-early-shipping])');
        var own = host.querySelector('[data-ss-early-shipping]');
        var cart = w.kachingCartApi && w.kachingCartApi.getCartData();
        var props = JSON.parse(host.getAttribute('kaching-cart-props') || 'null');
        var text = earlyShippingText(cart, props);
        if (!text && own && native && cart && cart.cartPromotionsState &&
            (!native.textContent.trim() || native.textContent.trim() === 'true')) return;
        if (!native || !text) {
          if (own) own.remove();
          if (native && native.classList.contains('ss-native-shipping-pending')) native.classList.remove('ss-native-shipping-pending');
          return;
        }
        if (!own) {
          own = w.document.createElement('p');
          own.className = 'kaching-cart__tiered-promotions-bar-text';
          own.setAttribute('data-ss-early-shipping', '');
          native.before(own);
        }
        if (own.textContent !== text) {
          var parts = text.split('Free shipping');
          var strong = w.document.createElement('strong');
          strong.textContent = 'Free shipping';
          own.replaceChildren(w.document.createTextNode(parts[0]), strong, w.document.createTextNode(parts[1]));
        }
        if (!native.classList.contains('ss-native-shipping-pending')) native.classList.add('ss-native-shipping-pending');
      } catch (_) {}
    }
    function schedule() {
      if (!queued) { queued = true; w.requestAnimationFrame(update); }
    }
    function start() {
      var style = w.document.createElement('style');
      style.textContent = 'kaching-cart .ss-native-shipping-pending { display: none !important; }';
      w.document.head.appendChild(style);
      new w.MutationObserver(schedule).observe(w.document.body, {childList: true, subtree: true});
      w.document.addEventListener('kaching-cart:cart-updated', schedule);
      update();
    }
    if (w.document.readyState === 'loading') w.document.addEventListener('DOMContentLoaded', start, {once:true});
    else start();
  }
  function install(w, config) {
    var options = Object.assign({ appUrl: 'https://securecheckout.sensorystall.com', cartJsonCompatibility: false, carryJourneyInUrl: true }, config);
    var tracker = createTracker(w, options);
    installCartJsonAdapter(w, options.cartJsonCompatibility);
    installCheckout(w, options, tracker); installEarlyShipping(w); tracker.start();
    return tracker;
  }
  return { earlyShippingText: earlyShippingText, consent: consent, createTracker: createTracker, cartJson: cartJson, installCartJsonAdapter: installCartJsonAdapter, installCheckout: installCheckout, createAttemptStore: createAttemptStore, install: install };
});
